module.exports = __webpack_public_path__ + "static/media/madhucon2.71cff8c5.png";